var path = '/app/components/dialogs/mission/mission.html';
var html = "<div class=caixa-dialogo> <h1 class=titulo>Novo Desafio</h1> <div class=conteudo> <p class=texto-missao ng-bind-html=$ctrl.missionText></p> </div> <div class=icon-box> <div ng-repeat=\"i in $ctrl.missionIcons\" class=\"{{ i }}\"></div> </div> <div class=btn> <div class=btn-cancela ng-click=$ctrl.cancel()></div> <div class=btn-aceita ng-click=$ctrl.ok()></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/mission/mission.html
// module id = 143
// module chunks = 0